import {
  BOOST,
  NAVIGATION,
  PRODUCT_QUERIES,
  OFFER_CODES,
  OFFER_GROUPS,
  PRODUCT_MERCH,
} from 'screens/pageKeys';

const SERVICE_TO_PAGE_KEY_MAPPING = {
  BOOSTER_SERVICE: BOOST,
  CATEGORIES_SERVICE: NAVIGATION,
  PRODUCT_QUERIES_SERVICE: PRODUCT_QUERIES,
  OFFER_GROUPS_SERVICE: OFFER_GROUPS,
  OFFER_CODES_SERVICE: OFFER_CODES,
  PRODUCT_MERCH_SERVICE: PRODUCT_MERCH,
};

export const permissionsMapper = permissionsResponse => {
  if (permissionsResponse.global === 'FULL') return getFullPermissions();
  if (permissionsResponse.global === 'NONE') return [];

  const services = permissionsResponse.services || [];
  const readOnlyServices = permissionsResponse.readOnlyServices || [];

  const permissions = [];

  services.forEach(service => {
    permissions.push({ pageKey: SERVICE_TO_PAGE_KEY_MAPPING[service], readOnly: false });
  });

  readOnlyServices.forEach(service => {
    if (!services.includes(service)) {
      permissions.push({ pageKey: SERVICE_TO_PAGE_KEY_MAPPING[service], readOnly: true });
    }
  });

  return permissions;
};

function getFullPermissions() {
  return Object.entries(SERVICE_TO_PAGE_KEY_MAPPING).map(([_, pageKey]) => {
    return { pageKey, readOnly: false };
  });
}
